<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="username">
      <Input v-model="form.username" placeholder="请输入用户名">
        <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem prop="password">
      <Input type="password" v-model="form.password" placeholder="请输入密码">
        <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem>
      <Checkbox v-model="form.remember">记住密码</Checkbox>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: 'LoginForm',
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ]
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      form: {
        username: '',
        password: '',
        remember: false
      }
    }
  },
  mounted () {
    // 从localStorage读取保存的用户名
    const savedUsername = localStorage.getItem('savedUsername')
    if (savedUsername) {
      this.form.username = savedUsername
    }
    
    // 从localStorage读取记住密码的状态
    const rememberPassword = localStorage.getItem('rememberPassword')
    if (rememberPassword === 'true') {
      this.form.remember = true
      // 如果记住密码，则读取保存的密码
      const savedPassword = localStorage.getItem('savedPassword')
      if (savedPassword) {
        this.form.password = savedPassword
      }
    }
  },
  computed: {
    rules () {
      return {
        username: this.userNameRules,
        password: this.passwordRules
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 保存用户名（总是保存）
          localStorage.setItem('savedUsername', this.form.username)
          
          // 根据记住密码选项保存或清除密码
          if (this.form.remember) {
            localStorage.setItem('savedPassword', this.form.password)
            localStorage.setItem('rememberPassword', 'true')
          } else {
            localStorage.removeItem('savedPassword')
            localStorage.removeItem('rememberPassword')
          }
          
          this.$emit('on-success-valid', {
            username: this.form.username,
            password: this.form.password
          })
        }
      })
    }
  }
}
</script>
